<p>{{ announcement.publishedDate | date: 'mediumDate' }}</p>
<h4>{{ announcement.title }}</h4>
<div [innerHTML]="announcement.content | safeHtml"></div>
